import dealerApi from '../../apis/dealer.api';
import * as types from '../mutation-types';
let getSpecListByDealerIdPromise = null;
let getSeriesInfoByDealerIdAndSeriesIdPromise = null;
let getMaxAmountCouponPromise = null;
export default {
  state: {
    dealerInfo: null,
    specList: [],
    vrSeriesInfo: null,
    salesSeriesId: 0,
    maxAmountOfCoupon: 0,
  },
  mutations: {
    [types.SET_DEALER_INFO](state, dealerInfo) {
      state.dealerInfo = dealerInfo;
    },
    [types.SET_DEALER_SPEC_LIST](state, specList) {
      state.specList = specList || [];
    },
    setSeriesInfo: function (state, vrSeriesInfo) {
      state.vrSeriesInfo = vrSeriesInfo;
    },
    setSalesSeriesId: function (state, seriesId) {
      state.salesSeriesId = seriesId;
    },
    setMaxAmountOfCoupon: function (state, amount) {
      state.maxAmountOfCoupon = amount;
    },
  },
  getters: {
    salesSeriesId: (state) => state.salesSeriesId,
    dealerInfo: (state) => state.dealerInfo,
    seriesList: (state) => state.specList,
    specList: (state) => (seriesId) => {
      let seriesItem = state.specList.find((o) => o.SeriesId === seriesId);
      if (seriesItem) {
        return seriesItem.SpecList;
      }
      return [];
    },
    specListWithOutZero: (state) => (seriesId) => {
      let seriesItem = state.specList.find((o) => o.SeriesId === seriesId);
      if (seriesItem) {
        return seriesItem.SpecList.filter((item) => {
          return item.MinPrice > 0;
        });
      }
      return [];
    },
    specItem: (state) => (seriesId, specId) => {
      let seriesItem = state.specList.find((o) => o.SeriesId === seriesId);
      if (seriesItem) {
        let specItem = seriesItem.SpecList.find((o) => o.SpecId === specId);
        if (specItem) {
          return specItem;
        }
      }
      return null;
    },
    seriesName: (state) => (seriesId) => {
      let seriesItem = state.specList.find((o) => o.SeriesId === seriesId);
      if (seriesItem) {
        return seriesItem.SeriesName;
      }
      return '';
    },
    specName: (state) => (seriesId, specId) => {
      let seriesItem = state.specList.find((o) => o.SeriesId === seriesId);
      if (seriesItem) {
        let specItem = seriesItem.SpecList.find((o) => o.SpecId === specId);
        if (specItem) {
          return specItem.SpecName;
        } else if (seriesItem.SpecList.length > 0) {
          return seriesItem.SpecList[0].SpecName;
        }
      }
      return '';
    },
    vrSeriesInfo: (state) => state.vrSeriesInfo,
    maxAmountOfCoupon: (state) => state.maxAmountOfCoupon,
  },
  actions: {
    getSpecListByDealerId({ commit }, dealerId) {
      if (getSpecListByDealerIdPromise) {
        return getSpecListByDealerIdPromise;
      }
      getSpecListByDealerIdPromise = dealerApi.getSpecListByDealerId(dealerId).then(function (data) {
        commit(types.SET_DEALER_SPEC_LIST, data);
        return data;
      });
      return getSpecListByDealerIdPromise;
    },
    getSeriesInfoByDealerIdAndSeriesId({ commit }, { dealerId, seriesId }) {
      if (getSeriesInfoByDealerIdAndSeriesIdPromise) {
        return getSeriesInfoByDealerIdAndSeriesIdPromise;
      }
      getSeriesInfoByDealerIdAndSeriesIdPromise = dealerApi
        .getSeriesInfoByDealerIdAndSeriesId(dealerId, seriesId)
        .then((data) => {
          if (data) {
            commit('setSeriesInfo', data);
          }
        })
        .catch((error) => {
          throw error;
        });
    },
    getMaxAmountCoupon({ commit }, { dealerId }) {
      if (getMaxAmountCouponPromise) {
        return getMaxAmountCouponPromise;
      }
      getMaxAmountCouponPromise = dealerApi.getMaxAmountCoupon(dealerId).then((data) => {
        if (data) {
          commit('setMaxAmountOfCoupon', data);
        }
      });
    },
  },
  namespaced: true,
};
